export const DEFAULT_IMAGE_CONTENT = {
  title: "A title or caption, specific to this image",
  description:
    "Mark your calendars and make sure to be there, you don't want to miss this edition.",
};

export const IMAGE_SLIDER_TEMPLATES = [
  {
    design: "slider-one",
    images: [
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: DEFAULT_IMAGE_CONTENT.title,
        description: DEFAULT_IMAGE_CONTENT.description,
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1530569673472-307dc017a82d?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: DEFAULT_IMAGE_CONTENT.title,
        description: DEFAULT_IMAGE_CONTENT.description,
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1509149037-37dc57ccbd13?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: DEFAULT_IMAGE_CONTENT.title,
        description: DEFAULT_IMAGE_CONTENT.description,
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1486520299386-6d106b22014b?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: DEFAULT_IMAGE_CONTENT.title,
        description: DEFAULT_IMAGE_CONTENT.description,
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1593006082891-00053bcb17b3?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: DEFAULT_IMAGE_CONTENT.title,
        description: DEFAULT_IMAGE_CONTENT.description,
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
    ],
    title: "The product vision workshop was engaging and compelling.",
    hasImagesTitle: false,
    hasImagesDescription: false,
    height: 50,
    hasTitle: false,
    viewType: "autocrop",
    autoplay: true,
    bullets: true,
    thumbnails: true,
    arrows: true,
    roundedCorners: false,
    advancedOptions: {
      borderRadius: 8,
      titleAlignment: "center",
      titleSize: 22,
      textAlignment: "left",
      textSize: 16,
    },
    slideIndex: 0,
    isLinkDialogOpen: false,
    advancedOptionsOpen: true,
  },
  {
    design: "slider-two",
    images: [
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: "",
        description: "",
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1530569673472-307dc017a82d?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: "",
        description: "",
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1509149037-37dc57ccbd13?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: "",
        description: "",
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1486520299386-6d106b22014b?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: "",
        description: "",
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
      {
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1593006082891-00053bcb17b3?q=80&w=1920&h=1080",
        id: crypto.randomUUID(),
        title: "",
        description: "",
        linkToPage: {
          id: "",
          link: "",
          title: "",
          type: "",
          source: "page",
          newTab: false,
        },
      },
    ],
    title: "The product vision workshop was engaging and compelling.",
    hasImagesTitle: false,
    hasImagesDescription: false,
    height: 50,
    hasTitle: false,
    viewType: "autocrop",
    autoplay: true,
    bullets: true,
    thumbnails: true,
    arrows: true,
    roundedCorners: false,
    aspectRatio: "squared",
    advancedOptions: {
      borderRadius: 8,
      titleAlignment: "left",
      titleSize: 22,
      textAlignment: "left",
      textSize: 16,
    },
    slideIndex: 0,
    isLinkDialogOpen: false,
    advancedOptionsOpen: true,
  },
];

export const getImageSliderTemplates = ({ cornerRadius }) =>
  IMAGE_SLIDER_TEMPLATES.map((template) => ({
    ...template,
    advancedOptions: {
      ...template.advancedOptions,
      borderRadius: cornerRadius || 8,
    },
  }));
